import LineChart from './line.PNG';
import ScatterChart from './scatter.PNG';

export default {
    LineChart,
    ScatterChart
};